import { providerFailure } from '../provider-error.js';
import { canRefreshFundingSession } from './payment-recovery.js';
export function fundingActionRunner(options) {
    const { active, setBusy, setError, setProviderFailure } = options;
    return async (action) => {
        if (active.current)
            return;
        const controller = new AbortController();
        active.current = controller;
        setBusy(true);
        setError(null);
        setProviderFailure(null);
        try {
            await action(controller.signal);
        }
        catch (failure) {
            if (!controller.signal.aborted) {
                if (canRefreshFundingSession(failure, options.hasAttempt()))
                    options.onSessionRefresh();
                else {
                    const failureDetails = providerFailure(failure);
                    setProviderFailure(failureDetails);
                    setError(failureDetails?.category ??
                        (failure instanceof Error && failure.message === 'funding_fx_unavailable'
                            ? 'funding_fx_unavailable'
                            : 'provider_unavailable'));
                }
            }
        }
        finally {
            if (active.current === controller)
                active.current = null;
            if (!controller.signal.aborted)
                setBusy(false);
        }
    };
}
